import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { findFeature } from '../../findFeature'
import { setLayerMetadata } from '../../layerMetadata'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Remove all the RoadSegments marked for removal in a Changelog coming form the data-layer
 */
export async function changelogRemoveRoadSegmentFeatures(
  layer: VectorLayer<VectorSource>,
  selection: Set<string>,
  markerIds: IterableIterator<string>,
) {
  nonblockingRender.reset()

  for (const markerId of markerIds) {
    const feature = findFeature(layer, markerId)

    // if a feature is not find to be removed fail silently
    if (feature) {
      await nonblockingRender.next()
      layer.getSource()?.removeFeature(feature)
    }
  }

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
